
import React from 'react';
import { BackgroundElements } from './hero/BackgroundElements';
import { HeroContent } from './hero/HeroContent';
import { AppPreview } from './hero/AppPreview';
import { useMediaQuery } from '@/hooks/use-media-query';
import { useIsMobile } from '@/hooks/use-mobile';

export function HeroSection() {
  const isMobile = useIsMobile();
  
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-sky-50 to-white min-h-[85vh] flex items-center w-full pb-8 md:pb-0">
      {/* Background elements */}
      <BackgroundElements />
      
      <div className="container mx-auto px-4 py-8 lg:py-24 z-10 relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-20 items-center">
          {/* Left Side - Content */}
          <HeroContent />
          
          {/* Right Side - App Preview */}
          <div className={`${isMobile ? 'mt-8' : ''}`}>
            <AppPreview />
          </div>
        </div>
      </div>
    </section>
  );
}
